(function() {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .factory('swifPatrimoineEquipmentMovementService', swifPatrimoineEquipmentMovementService)
    .factory('swifPatrimoineEquipmentMovementLinesService', swifPatrimoineEquipmentMovementLinesService)
    .factory('swifPatrimoineEquipmentMovementLinesViewService', swifPatrimoineEquipmentMovementLinesViewService)
    .controller('PatrimoineEquipmentsMovementsController', PatrimoineEquipmentsMovementsController)
    .controller('PatrimoineMovementModalController', PatrimoineMovementModalController)
    .controller('EquipmentMovementLinesViewController', EquipmentMovementLinesViewController)
    .component('equipmentMoveLinesTable', {
        templateUrl: 'partials/patrimoine/equipment_movement_lines_table_directive.html',
        controller: EquipmentMovementLinesController,
        bindings: {
            'equipmentId': '<'
        }
    });


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/equipment-movements/table_view', {
            templateUrl: 'partials/patrimoine/equipment_movements_tables.html',
            controller: PatrimoineEquipmentsMovementsController,
            reloadOnSearch: false,
            resolve: {
                data: function(swifPatrimoineEquipmentMovementService) {
                    return swifPatrimoineEquipmentMovementService.resolveData();
                }
            }
        })

        $routeProvider.when('/patrimoine/equipment-movements/movements_view', {
            templateUrl: 'partials/patrimoine/equipment_movement_lines_view.html',
            controller: EquipmentMovementLinesViewController,
            reloadOnSearch: false,
            resolve: {
                data: function(swifPatrimoineEquipmentMovementLinesViewService) {
                    return swifPatrimoineEquipmentMovementLinesViewService.resolveData();
                }
            }
        })
    }


    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineEquipmentMovementService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineEquipmentMovementService(swif, $q) {
        'ngInject';
        var service = {};
        service.swif = swif;

        swif.settings.initialize().then(settings => {
            var contentType = settings.getContentType('equipment_movement');
            service.COLLECTION_NAME = contentType.collectionName;
        });

        service.createCollection = function () {
            var filter = {};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.COLLECTION_NAME,
                'equipment_movement',
                filter,
                {location: true}
            );
        };

        service.getCollection = function() {
            return swif.collections.getCollection(service.COLLECTION_NAME);
        };

        service.resolveData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createCollection());
                $q.all(defers).then(function (res) {
                    var data = res[0];
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.callback = function (error, data) {
            var collection = swif.collections.getCollection(service.COLLECTION_NAME);
            collection.refresh();
        }

        service.getFilters = function (request) {
            var filters = {
                equipment: {fields:  ['id', 'name', 'complete_name', 'equipment_reference']},
                partner: {},
                partnerAddress: {fields: ['name', 'complete_name', 'partner_id', 'is_active']}
            };
            swif.data.addFilter(
                filters.partner,
                'is_department', '=', false
            );
            if (request.equipmentCategIds && _.isArray(request.equipmentCategIds) && request.equipmentCategIds.length > 0) {
                swif.data.addFilter(
                    filters.equipment,
                    'categ_id', 'in', request.equipmentCategIds
                );
            } else {
                swif.data.addFilter(
                    filters.equipment,
                    'categ_id.is_key', '=', false
                );
                swif.data.addFilter(
                    filters.equipment,
                    'categ_id.is_vehicle', '=', false
                );
                swif.data.addFilter(
                    filters.equipment,
                    'categ_id.is_fluid_meter', '=', false
                );
            }
            return filters;
        }

        service.preModal = function (data) {
            if (data.action.id === "move_equipment") {
                data.model.equipmentIds = [angular.copy(data.model.equipment_id[0])];
            }
        }

        service.createMovementLines = function (vals, fields) {
            return swif.data.create('equipment_movement_line', vals, undefined, fields)
                .then(function (data) {
                    return data;
                });
        }

        service.saveMovementLines = function (model) {
            var movementLinesFields = ['move_date', 'type', 'external_holder', 'site_id', 'equipment_ids', 'holder_name', 'holder_phone'];
            var newModel = {};
            newModel.move_date = model.date;
            newModel.type = model.equipmentMoveType === 'comeBack' ? 'come_back' : model.equipmentMoveType;
            newModel.external_holder = model.externalHolder;
            newModel.site_id = model.siteId;
            newModel.equipment_ids = model.equipmentIds;
            newModel.holder_name = model.externalHolderName ? model.externalHolderName : null;
            newModel.holder_phone = model.externalHolderPhone ? model.externalHolderPhone : null;
            // if (model.externalHolder) {
            //     movementLinesFields.push('holder_name', 'holder_phone');
            // } else {
            // }
            const hIsArray = _.isArray(model.holder);
            movementLinesFields.push('holder_contact', 'holder_partner', 'holder_department');
            newModel.holder_contact = (model._typeHolder === 'user' && hIsArray) ? model.holder : null;
            newModel.holder_partner = (model._typeHolder === 'partner' && hIsArray) ? model.holder : null;
            newModel.holder_department = (model._typeHolder === 'department' && hIsArray) ? model.holder : null;
            return service.createMovementLines(newModel, movementLinesFields);
        }

        service.preValidate = function (data) {
            var ret;
            if (data.action.id === 'add' || data.action.id === 'move_equipment') {
                ret = service.saveMovementLines(data.model);
            } else {
                ret = service.getCollection().preValidate(data);
            }
            return ret;
        }

        return service;
    }


    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineEquipmentMovementLinesService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineEquipmentMovementLinesService(swif) {
        'ngInject';

        var service = {};

        service.createCollection = function (equipmentId) {
            var filter = {fields: [
                'id', 'type', 'move_date', 'holder', 'holder_contact', 'holder_department', 'external_holder', 'site_name', 'equipment_name'
            ]};
            swif.data.sortOn(filter, 'move_date', 'DESC');
            swif.data.setLimit(filter, 10);
            swif.data.addExtraFilter(filter, 'equipment', 'equipment_id', '=', equipmentId);
            return swif.collections.createOrUpdate('equipmentMovementLines', 'equipment_movement_line', filter);
        }

        service.getCollection = function() {
            return swif.collections.getCollection('equipmentMovementLines');
        };

        service.callback = function (error, data) {
            var collection = swif.collections.getCollection(service.COLLECTION_NAME);
            collection.refresh();
        }

        return service;
    }


    /**
        * @ngdoc service
        * @name swif.patrimoine.swifPatrimoineEquipmentMovementLinesViewService
        * @requires swif.framework.swifFrameworkService
    **/
    function swifPatrimoineEquipmentMovementLinesViewService(swif, $q) {
        'ngInject';

        var service = {};
        service.swif = swif;

        swif.settings.initialize().then(settings => {
            var contentType = settings.getContentType('equipment_movement_line');
            service.COLLECTION_NAME = contentType.collectionName;
        });

        service.createCollection = function () {
            var filter = {fields: [
                'id', 'equipment_id', 'equipment_name', 'type', 'move_date', 'holder', 'holder_contact', 'holder_department', 'external_holder', 'site_name'
            ]};
            swif.data.sortOn(filter, 'id', 'DESC');
            return swif.collections.createOrUpdate(
                service.COLLECTION_NAME,
                'equipment_movement_line',
                filter,
                {location: true}
            );
        }

        service.getCollection = function() {
            return swif.collections.getCollection(service.COLLECTION_NAME);
        };

        service.resolveData = function () {
            var ret = $q.defer();
            swif.route.check().then(function () {
                var defers = [];
                defers.push(service.createCollection());
                $q.all(defers).then(function (res) {
                    var data = res[0];
                    ret.resolve(data);
                });
            });
            return ret.promise;
        };

        service.callback = function (error, data) {
            var collection = swif.collections.getCollection(service.COLLECTION_NAME);
            collection.refresh();
        }

        return service;
    }


    function PatrimoineEquipmentsMovementsController($scope, $location, data, swif, swifPatrimoineEquipmentMovementService) {
        'ngInject';
        console.log('init PatrimoineEquipmentsMovementsController');
        var service = swifPatrimoineEquipmentMovementService;

        $scope.equipments = data;
        $scope.callback = service.callback;
        $scope.preValidate = service.preValidate;
        $scope.preModal = service.preModal;
    }


    function PatrimoineMovementModalController($scope, swif, swifPatrimoineEquipmentMovementService, openbase) {
        'ngInject';
        console.log('init PatrimoineMovementModalController');
        var service = swifPatrimoineEquipmentMovementService;

        var user = swif.user.getAuthenticatedUserData();
        $scope.filters = {};
        $scope.formatNameChoices = openbase.utils.selectOneFormatNameChoice;
        $scope.model.equipmentMoveType = 'assignment'; // or 'comeBack'
        $scope.model.externalHolder = false;
        $scope.model.equipmentCategIds = user.equipment_categories_ids;
        // $scope.equipmentFilter = service.getFilter(user.equipment_categories_ids);
        $scope.model._typeHolder = 'partner'; // or 'user' or 'department'

        $scope.changeHolderType = changeHolderType;

        updateFilters();

        function updateFilters() {
            $scope.filters = service.getFilters($scope.model);
        }

        function changeHolderType(type) {
            $scope.model._typeHolder = type;
            $scope.model.holder = undefined;
        }
    }


    function EquipmentMovementLinesController($scope, swifFrameworkService, swifPatrimoineEquipmentMovementLinesService) {
        'ngInject';
        console.log('init EquipmentMovementLinesController');

        var $ctrl = this;
        var swif = swifFrameworkService;
        var service = swifPatrimoineEquipmentMovementLinesService;
        $ctrl.callback = service.callback;

        function initialize() {
            var equipmentId = _.isNumber($ctrl.equipmentId) ? $ctrl.equipmentId : $ctrl.equipmentId[0];
            service.createCollection(equipmentId)
            .then(function(collection) {
                $ctrl.movementLines = collection;
            });
        }
        initialize();

        $scope.$watch('$ctrl.equipmentId', function (newV, oldV) {
            if (newV !== oldV) {
                initialize();
            }
        });
    }


    function EquipmentMovementLinesViewController($scope, $location, data, swif, swifPatrimoineEquipmentMovementLinesService) {
        'ngInject';

        var service = swifPatrimoineEquipmentMovementLinesService;

        $scope.movements = data;
        $scope.callback = service.callback;
        $scope.preValidate = service.preValidate;
        $scope.preModal = service.preModal;
    }

})();
